<template>
  <div>
    <div id="footer">
      <div class="center_footer">
        <div class="bottom_left">宜宾天亿新材料科技有限公司版权所有
          <a href="https://beian.miit.gov.cn/"> 蜀ICP备2022018661号-1</a>
        </div>
        <!-- <div class="bottom_right">
          <a href="http://www.langqiyun.com/">技术支持：浪起科技有限公司</a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped lang='scss'>
#footer {
  width: 100vw;
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: center;
  position: relative;
  
  .center_footer {
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    z-index: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255,255,255,.8);
    .bottom_left{
      text-align: center;width: 100%;
    }
    a {
      color: rgba(255,255,255,.8);
      outline: none;
      text-decoration: none;
    }
  }
}
</style>